<template>
  <component :is="componentName" ref="autocomplete" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { openApiMixin } from './BAutocompleteCommon/mixins'


const TYPES = {
  FILE: 'file',
  BASE_EVENT: 'base-event',
  EVENT_STATUS: 'event-status',
  SELECT: 'select',
  FILE_TAG: 'file-tag',
  FILE_TYPE: 'file-type',
  FORM_TEMPLATE: 'form-template',
  FORMS_HANDBOOK: 'forms-handbook',
  REGION: 'region',
  PARTICIPANT: 'participant',
  MUNICIPALITY: 'municipality',
  SCHOOL: 'school',
  STORAGE_TYPE: 'storage-type',
  TIMEZONE: 'timezone',
  TOPIC: 'topic',
  USER: 'user',
  USER_GROUP: 'user-group',
  PROCEDURE: 'procedure',
  EVENT_PUBLICATIONS: 'event-publications',
  EVENT_PUBLICATIONS_STORAGES: 'event-publications-storages',

  PERMISSION: 'permission',
  PERMISSION_APPLICATION: 'permission-application',
  PERMISSION_INFO_MODEL: 'permission-info-model',
  PERMISSION_TYPE: 'permission-type',
  PUBLICATION: 'publication',

  SHEET_CELL_TYPE: 'sheet-cell-type',
  SHEET_CELL_TYPE_METHOD: 'sheet-cell-type-method',

  DATA_COLLECTION: 'data-collection',
}

const getComopnent = ({ $type }) => {
  switch ($type) {
    case TYPES.FILE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.file" */
        './BAutocompleteCommon/BAutocompleteFile.vue'
      )

    case TYPES.BASE_EVENT:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.base-event" */
        './BAutocompleteCommon/BAutocompleteBaseEvent.vue'
      )

    case TYPES.EVENT_STATUS:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.event-status" */
        './BAutocompleteCommon/BAutocompleteEventStatus.vue'
      )

    case TYPES.SELECT:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.select" */
        './BAutocompleteCommon/BAutocompleteSelect.vue'
      )

    case TYPES.FILE_TAG:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.file-tag" */
        './BAutocompleteCommon/BAutocompleteFileTag.vue'
      )

    case TYPES.FILE_TYPE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.file-type" */
        './BAutocompleteCommon/BAutocompleteFileType.vue'
      )

    case TYPES.FORM_TEMPLATE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.form-template" */
        './BAutocompleteCommon/BAutocompleteFormTemplate.vue'
      )

    case TYPES.FORMS_HANDBOOK:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.forms-handbook" */
        './BAutocompleteCommon/BAutocompleteFormsHandbook.vue'
      )

    case TYPES.MUNICIPALITY:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.municipality" */
        './BAutocompleteCommon/BAutocompleteMunicipality.vue'
      )

    case TYPES.PARTICIPANT:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.participant" */
        './BAutocompleteCommon/BAutocompleteParticipant.vue'
      )

    case TYPES.REGION:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.region" */
        './BAutocompleteCommon/BAutocompleteRegion.vue'
      )

    case TYPES.SCHOOL:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.school" */
        './BAutocompleteCommon/BAutocompleteSchool.vue'
      )

    case TYPES.TIMEZONE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.timezone" */
        './BAutocompleteCommon/BAutocompleteTimezone.vue'
      )

    case TYPES.TOPIC:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.topic" */
        './BAutocompleteCommon/BAutocompleteTopic.vue'
      )

    case TYPES.PROCEDURE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.procedure" */
        './BAutocompleteCommon/BAutocompleteProcedure.vue'
      )

    case TYPES.STORAGE_TYPE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.storage-type" */
        './BAutocompleteCommon/BAutocompleteStorageType.vue'
      )

    case TYPES.USER:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.user" */
        './BAutocompleteCommon/BAutocompleteUser.vue'
      )

    case TYPES.USER_GROUP:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.user" */
        './BAutocompleteCommon/BAutocompleteUserGroup.vue'
      )

    case TYPES.PERMISSION:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.permission" */
        './BAutocompleteCommon/BAutocompletePermission.vue'
      )

    case TYPES.PERMISSION_APPLICATION:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.permission.application" */
        './BAutocompleteCommon/BAutocompletePermissionApplication.vue'
      )

    case TYPES.PERMISSION_INFO_MODEL:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.permission.info-model" */
        './BAutocompleteCommon/BAutocompletePermissionInfoModel.vue'
      )

    case TYPES.PERMISSION_TYPE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.permission.type" */
        './BAutocompleteCommon/BAutocompletePermissionType.vue'
      )

    case TYPES.PUBLICATION:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.publication" */
        './BAutocompleteCommon/BAutocompletePublication.vue'
      )

    case TYPES.EVENT_PUBLICATIONS:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.publication" */
        './BAutocompleteCommon/BAutocompleteEventPublications.vue'
      )

    case TYPES.EVENT_PUBLICATIONS_STORAGES:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.publication" */
        './BAutocompleteCommon/BAutocompleteEventPublicationsStorages.vue'
      )

    case TYPES.SHEET_CELL_TYPE:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.sheet-cell-type" */
        './BAutocompleteCommon/BAutocompleteSheetCellType.vue'
      )

    case TYPES.SHEET_CELL_TYPE_METHOD:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.sheet-cell-type-method" */
        './BAutocompleteCommon/BAutocompleteSheetCellTypeMethod.vue'
      )

    case TYPES.DATA_COLLECTION:
      return () => import(
        /* webpackChunkName: "b-autocomplete-common.data-collection" */
        './BAutocompleteCommon/BAutocompleteDataCollection.vue'
      )

    default:
      return process.env.NODE_ENV === 'development'
        && {
          functional: true,
          render: (h) => h(
            'div',
            {
              class: 'red white--text align-center justify-center',
              style: 'height: 100%; display: flex;',
            },
            `Type "${$type}" for <b-autocomplete-common /> not supported`,
          ),
        }
  }
}

export default {
  name: 'BAutocompleteCommon',
  mixins: [
    openApiMixin,
  ],
  inheritAttrs: false,
  props: {
    $type: {
      type: String,
      required: true,
      validator: (prop) => Object.values(TYPES).includes(prop),
    },
  },
  computed: {
    componentName() {
      return getComopnent(this)
    },
  },
}
</script>
